<div class="row">
    <feature-ad id="1" [ngClass]="{'loading-small':loading, 'col-lg-4':true, 'feature':true}" (click)="openResultsWithLocation()">
    </feature-ad>
    <feature-ad id="2" [ngClass]="{'loading-small':loading, 'col-lg-4':true, 'feature':true}" (click)="openResultsWithWaSelector()">
    </feature-ad>
    <feature-ad id="3" [ngClass]="{'loading-small':loading, 'col-lg-4':true, 'feature':true}" link="/articles-search">
    </feature-ad>
</div>
